<template>
  <div v-if="value > 0" class="chip-bet-content">
    <!-- <Chip 
      v-for="(val, index) in chips"
      :key="index"
      :value="val" 
    /> -->
    <img :src="chiplayout" class="chip-bet">
    <div class="chip-number">
      {{ value }}
    </div>
    <div class="no-stroke chip-number">
      {{ value }}
    </div>
  </div>
</template>

<script>
import { calculateChipStack } from '@utils/chip.js';
import Chip from '@components/common/chip.vue';

// eslint-disable-next-line no-unused-vars
import {mapActions, mapState} from 'vuex';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Chip,
  },
  props: {
    value: { type: Number, default: 0 }
  },
  computed: {
    chips: function(){
      // return calculateChipStack(100);
      return calculateChipStack(this.value);
    },
    chiplayout: function(){
      switch (true){
        case this.value < 50:
          return '/images/chip_1_layout.png';
        case this.value >= 50 && this.value < 100:
          return '/images/chip_50_layout.png';
        case this.value >= 100 && this.value < 500:
          return '/images/chip_100_layout.png';
        case this.value >= 500 && this.value < 1000:
          return '/images/chip_500_layout.png';
        case this.value >= 1000 && this.value < 5000:
          return '/images/chip_1k_layout.png';
        default:
          return '/images/chip_5k_layout.png';
      }
    },
  },
  methods: {
    
  },
}
</script>

<style>

</style>
